module.exports = __webpack_public_path__ + "static/img/tdlc.5d2c1c42.png";